import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontLeftHeadlightProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontLeftHeadlight(props: FrontLeftHeadlightProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Left Headlight"
      width={85}
      height={82}
      viewBox="0 0 85 82"
      position={{bottom: 24, left: 37}}
    >
      <path
        d="M61.8888 80.6817C29.6613 64.8375 1.68978 11.9597 1.68978 11.9597C-0.316853 7.97582 2.6931 2 2.6931 2C24.0097 31.0795 69.6613 70.4494 83.9617 73.7099C84.965 74.7058 65.9404 82.6736 61.8888 80.6817Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M61.8888 80.6817C29.6613 64.8375 1.68978 11.9597 1.68978 11.9597C-0.316853 7.97582 2.6931 2 2.6931 2C24.0097 31.0795 69.6613 70.4494 83.9617 73.7099C84.965 74.7058 65.9404 82.6736 61.8888 80.6817Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
